import {useAuthStore} from "../../store/auth.store";
import {useEffect, useState} from "react";
import {useVendorsStore} from "../../store/vendors.store";
import {useVendors} from "../../hook/partner/vendors.partner.hook";
import {PartnerApi} from "../../api/partner.api";
import {NavLink} from "react-router";
import {useBreadcrumbsStore} from "../../store/breadcrumbs.store";
import {useCompanyStore} from "../../store/company.store";
import {useCompany} from "../../hook/partner/company.partner.hook";
import {useUsers} from "../../hook/partner/users.partner.hook";
import {useUserRoleSchema} from "../../hook/partner/userRoleSchema.partner.hook";
import {useUsersStore} from "../../store/users.store";
import {Role} from "../../utils/Role";
import {toast} from "react-toastify";
import CompanyBranchNewModal from "../../components/modals/company/CompanyBranchNewModal";
import CompanyBranchEditModal from "../../components/modals/company/CompanyBranchEditModal";
import { useTranslation } from "../../hooks/useTranslation";
import CompanyBranchPeoplesModal from "../../components/modals/company/CompanyBranchPeoplesModal";

function SettingsCompanyBranches() {
    const { t } = useTranslation();
    const companyMutation = useCompany();
    const usersMutation = useUsers();

    const token = useAuthStore((state) => state.token);
    const user = useAuthStore((state) => state.user);
    const users = useUsersStore((state) => state.users);
    const company = useCompanyStore((state) => state.company);
    const company_id = user?.current_person?.company_id;

    const [showModal, setShowModal] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [showModalPeoples, setShowModalPeoples] = useState(false);

    const [reload, setReload] = useState(0);

    const setBreadcrumbs = useBreadcrumbsStore((state) => state.setBreadcrumbs);
    const setPagename = useBreadcrumbsStore((state) => state.setPagename);
    useEffect(() => {
        setPagename(t("settings.title"));
        setBreadcrumbs([]);
    }, []);

    useEffect(() => {
        if (user && token && company_id) {
            companyMutation.mutate({
                token, company_id
            })
            usersMutation.mutate({
                token,
            });
        }
    }, [user, token, reload]);

    if (companyMutation.isLoading) {
        return <p>{t("common.loading")}</p>;
    }


    const changeRole = (person_id, role_id, value) => {
        const result = PartnerApi.userRoleChange({
            token,
            person_id,
            role_id,
            value
        });
        result.then((result) => {
            if ("error" in result) {
                toast.error(result.error);
                return;
            }
            toast.success(t("common.saved"));
        });
        return false;
    }

    const deleteCompanyBranch = (company_branch_id) => {
        if (!window.confirm(t("common.delete") + "?")) {
            return;
        }

        const result = PartnerApi.companyCompanyBranchDelete({
            token,
            company_id: company.company_id,
            company_branch_id,
        });
        result.then((result) => {
            if ("error" in result) {
                setReload(reload+1);
                toast.error(result.error);
                return;
            }
            setReload(reload+1);
            toast.success(t("companyBranch.deleted"));
        });
        return false;
    }

    return (
        <>
            {company && "error" in company ? (
                <p className="alert alert-danger">{company.error}</p>
            ) : (company && (
                <>
                    <div className="mb-10">
                        <CompanyBranchNewModal
                            show={showModal} handleClose={()=>setShowModal(false)}
                            callback={()=>setReload(reload+1)}
                            company_id={company.company_id} id={"delivery-company_branch-new"}/>

                        <button className="btn btn-primary"
                                onClick={()=>setShowModal(true)}>
                            <i className="ki-duotone ki-plus fs-2">
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                            {t("companyBranch.add")}
                        </button>
                    </div>

                    {company.branches && company.branches.length > 0 ? (
                        <div className="row">
                            {company.branches.map((company_branch, akey) => (
                                <div className="col-sm-6 col-md-4 mb-6" key={akey}>
                                    <CompanyBranchEditModal
                                        show={showModalEdit===company_branch.company_branch_id}
                                        handleClose={()=>setShowModalEdit(false)}
                                        callback={()=>setReload(reload+1)}
                                        company_id={company.company_id}
                                        company_branch={company_branch}/>

                                    <CompanyBranchPeoplesModal
                                        show={showModalPeoples===company_branch.company_branch_id}
                                        handleClose={()=>setShowModalPeoples(false)}
                                        callback={()=>setReload(reload+1)}
                                        company_id={company.company_id}
                                        users={users}
                                        company_branch={company_branch}/>

                                    <div className="card h-100">
                                        <div className="card-header">
                                            <div className="card-title">

                                                {company_branch.name}
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="mb-5">
                                            {company_branch.street}<br/>
                                            {company_branch.city}<br/>
                                            {company_branch.zip}<br/>
                                            {company_branch.state}
                                            </div>

                                            <button className="btn btn-sm btn-primary me-2"
                                                    onClick={()=>setShowModalEdit(company_branch.company_branch_id)}
                                            >
                                                <i className="ki-duotone ki-pencil fs-4">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                    <span className="path4"></span>
                                                    <span className="path5"></span>
                                                </i>
                                                {t("common.edit")}
                                            </button>


                                            <button className="btn btn-sm btn-primary me-2"
                                                    onClick={()=>setShowModalPeoples(company_branch.company_branch_id)}
                                            >
                                                <i className="ki-duotone ki-pencil fs-4">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                    <span className="path4"></span>
                                                    <span className="path5"></span>
                                                </i>
                                                {t("companyBranch.peoples")}
                                            </button>

                                            <button className="btn btn-sm btn-danger"
                                                    onClick={() => deleteCompanyBranch(company_branch.company_branch_id)}
                                            >
                                                <i className="ki-duotone ki-trash fs-4">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                    <span className="path4"></span>
                                                    <span className="path5"></span>
                                                </i>
                                                {t("common.delete")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>{t("deliveryAddress.notFound")}</p>
                    )}
                </>
            ))}

        </>
    );
}

export default SettingsCompanyBranches;
